import styled from "styled-components";
import RadioCheckmark from "./RadioCheckmark";
import RadioDot from "./RadioDot";

export default styled.label`
  display: flex;
  align-items: center;
  position: relative;
  // margin: 0 1rem;
  margin: 0;
  margin-right: 1rem;
  cursor: pointer;
  font-size: 1rem;
  user-select: none;
  height: 5.4rem;

  &:hover {
    & > input ~ ${RadioCheckmark} {
      border: 1px solid #738a94;
    }

    & > input ~ ${RadioDot} {
      border: 1px solid #738a94;
    }
  }
`;
